import React from 'react';
import { Route, Redirect, RouteProps } from 'react-router-dom';
import { useFlags } from 'launchdarkly-react-client-sdk';

const RootPrivateRoute: React.FC<RouteProps> = ({ children, ...rest }) => {
  const {
    enableInternalSignUp
  } = useFlags();

  return (
    <Route
      {...rest}
      render={() =>
        enableInternalSignUp ? (
          <>{children}</>
        ) : (
          <Redirect to="/dashboard" />
        )
      }
    />
  );
};

export default RootPrivateRoute;
